/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GroupDetailOutputDto { 
    id?: number;
    groupName?: string | null;
    userId?: number | null;
    chairmanName?: string | null;
    chairmanMobileNumber?: string | null;
    groupRegion?: string | null;
    groupDistrict?: string | null;
    groupWard?: string | null;
    officeNumber?: string | null;
    membersCount?: number;
    groupNumber?: string | null;
    groupType?: string | null;
    groupUserId?: number;
    policy?: string | null;
    policyId?: number | null;
    memberId?: string | null;
    typeId?: number | null;
    branchName?: string | null;
    branchId?: number | null;
    relationshipManager?: string | null;
    relationshipManagerId?: number | null;
    relationshipManagerTitle?: string | null;
    referenceId?: string | null;
    frequency?: string | null;
    meetingDay?: string | null;
    meetingDate?: string | null;
}

